module.exports = __webpack_public_path__ + "static/media/AccountActive.320d49e5.svg";